import React, { useState } from "react";
import NextLink from "components/parts/NextLink";
import { Item } from "../style";
import { Body } from "components/parts/Typography";
import HoverUnderline from "components/parts/HoverUnderline";
import type { AppTheme } from "themes/global";
import type { NavLinkProps } from "../navigation-links";
import { isTouchDevice } from "./MenuItemWithDropdown";
import { useNavigation } from "../NavigationContext";

interface DirectLinkMenuItemProps {
  item: NavLinkProps;
  theme: AppTheme;
}

const DirectLinkMenuItem = ({ item, theme }: DirectLinkMenuItemProps) => {
  const [isHovered, setIsHovered] = useState(false);
  const isTouch = isTouchDevice();
  const { setActiveMenu } = useNavigation();

  return (
    <Item
      theme={theme}
      onMouseEnter={() => {
        setIsHovered(true);
        if (!isTouch) setActiveMenu(null);
      }}
      onMouseLeave={() => setIsHovered(false)}
    >
      <NextLink href={item.url} id={item.id} prefetch={item.prefetch}>
        <Body size="sm" m="0" semiBold color={theme.textColors.primary}>
          <HoverUnderline
            underlineColor={theme.textColors.primary}
            active={isHovered}
          >
            <span>{item.name}</span>
          </HoverUnderline>
        </Body>
      </NextLink>
    </Item>
  );
};

export default DirectLinkMenuItem;
